<template>
	<div v-if="product">
		<LazyProductProductCardRowView
			v-if="rowView"
			:product="product"
			:click-is-valid="clickIsValid"
			:lazy-loading="lazyLoading"
			:quantity="quantity"
			:route-to-product="routeToProduct"
			@click="handleClick"
			@update:quantity="$emit('update:quantity', $event)"
		/>
		<ProductProductCardGridView
			v-else
			:product="product"
			:click-is-valid="clickIsValid"
			:is-carousel="isCarousel"
			:lazy-loading="lazyLoading"
			:picture-size="pictureSize"
			:picture-aspect-ratio="pictureAspectRatio"
			:route-to-product="routeToProduct"
			@click="handleClick"
		/>
	</div>
</template>

<script setup lang="ts">
import { parametricsSeedToQuery } from "~/utils/parametricsUrl";
import { computed } from "vue";
import type { FilteredProductItem } from "@nwt/norce-pwa/dist/runtime/types/api/searchAndFilter/filters";
import type {
	ParametricListValue,
	ProductItem
} from "@nwt/norce-pwa/dist/runtime/types/api/product/product";
import { useGtmEvents } from "~/composables/useGtmEvents";

interface Props {
	product:
		| Partial<FilteredProductItem & { qty: number }>
		| (ProductItem & { qty: number });
	pictureSize: string;
	pictureAspectRatio?: string;
	clickIsValid?: boolean;
	lazyLoading: boolean | undefined;
	isCarousel?: boolean;
	rowView?: boolean;
	quantity?: number;
	allParametrics?: ParametricListValue[];
}
const {
	product,
	pictureAspectRatio,
	pictureSize,
	lazyLoading,
	clickIsValid = true,
	isCarousel = false,
	rowView = false,
	allParametrics
} = defineProps<Props>();

defineEmits(["update:quantity"]);

const { productClick } = useGtmEvents();
const localePath = useLocalePath();

const routeToProduct = computed(() => {
	const path = localePath(`/${product?.UniqueName}`);
	if (!product?.ParametricListSeed || !product?.VariantParametricSeed?.length) {
		return path;
	}
	if (allParametrics?.length) {
		const query = parametricsSeedToQuery(
			product.ParametricListSeed,
			allParametrics
		);
		return Object.keys(query).length ? { path, query } : path;
	}
	return path;
});

const handleClick = () => {
	if (clickIsValid) {
		productClick(product);
	}
};
</script>
